module.exports = __webpack_public_path__ + "img/cerita_tokomutiarabali.72073eda.png";